'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var en_US = {
  // pay
  www_title: 'CalendarTask',
  www_homepage: 'Homepage',
  www_keywords: 'CalendarTask,notes,remind,calendar,countdown,to do,todoist,note,schedule,task,memo,good note,reminders,checklist',
  www_description: 'It can be displayed transparently on the desktop wallpaper. Double-click to edit and record trivia, schedule, repetitive tasks, etc. Support multi-terminal sync of data, real-time sharing of data, teamwork. ',
  update_log: '',
  more_function: 'More feature introductions',
  slogan_text1: 'It can be displayed transparently on the desktop wallpaper. ',
  slogan_text2: 'Double-click to edit and record trivia, schedule, repetitive tasks, etc. ',
  slogan_text3: 'Support multi-terminal sync of data, real-time sharing of data, teamwork. ',
  slogan_h5: 'The computer version can be displayed transparently on the desktop wallpaper. Double-click to edit and record trivia, schedule, repetitive tasks, etc. Support multi-terminal sync of data, real-time sharing of data, teamwork.',
  android_download: 'Download',
  ios_download: 'App Store',
  support_system: 'The following platforms are supported',
  windows_button: 'Windows',
  mac_button: 'Mac',
  linux_button: 'Linux',
  linux_op_x86: 'X86 version',
  linux_op_arm64: 'ARM64 version',
  iphone_button: 'iPhone',
  android_button: 'Android',
  scan_download_phone: 'Download mobile client',
  content_title1: 'Real-time data sync',
  content_text1: 'You can synchronize your schedule in real time between PC computers, Mac computers, and mobile phones.\nIf you are a small team, you can also achieve team collaboration.',
  content_title2: 'Transparent display',
  content_text2: 'You can pin directly to the desktop wallpaper, press the shortcut key to return to the desktop to edit and view your schedule and calendar information',
  content_title3: 'Repeat event',
  content_text3: 'Important anniversaries, credit card repayments, student courses, etc. can be set to repeat tasks and displayed on the calendar',
  content_title4: 'A calendar you want',
  content_text4: 'No matter your industry is white-collar workers, students, teachers, IT, government agencies, or finance, the powerful calendar setting function can always meet your needs',
  support: 'Support',
  support_title: 'CalendarTask-Support',
  support_text1: 'If you have any comments and suggestions, please email us \n Email: service@xiaoweiyunfu.com',
  support_text2: '',
  help: '',
  pay_title: 'CalendarTask-Function Introduction',
  cata_basic_intro_title: 'Function introduction',
  cata_basic_intro_title1: 'Multi device data sync(manual)',
  basic_intro_title1: 'Multiple device data synchronization',
  basic_intro_subtitle1: 'Whether you are using a mobile phone, computer or iPad, you can easily synchronize your data. ',
  basic_intro_text1: 'You need to log in with the same account on the synchronized device. <p class="p" /><font color="#FE776D">Which device has data, you need to click the cloud button on that device to manually synchronize the data. At this time, the data just recorded will be displayed on other devices. </font><p class="p" />',
  cata_basic_intro_title2: 'Calendar Memo',
  basic_intro_title2: 'Calendar Memo',
  basic_intro_subtitle2: 'Record trivial matters in the form of a calendar, concise but not simple. ',
  basic_intro_text2: 'You can double-click any date on the calendar, and an edit box will pop up for you to record trivia. <p class="p" />Press Enter to change to a new line to record new tasks. ',
  cata_basic_intro_title3: 'Reminder',
  basic_intro_title3: 'Reminder',
  basic_intro_subtitle3: 'Don\'t miss anything important, you can add reminders to remind yourself in real time. ',
  basic_intro_text3: 'Click the reminder button below the edit box to add a reminder. <p class="p" />The reminder function supports powerful personalization settings. You can define the recurrence type, end date, number of reminders, reminder time, etc. ',
  cata_basic_intro_title4: 'Countdown',
  basic_intro_title4: 'Countdown',
  basic_intro_subtitle4: 'Don\'t forget every important day, you can set the countdown day to remind yourself. ',
  basic_intro_text4: 'Click the countdown day button below the edit box to add a countdown day. <p class="p" />We divide the countdown day into five categories (birthdays, holidays, anniversaries, exams and default), and create beautiful countdown day cards for you so that you can remind yourself more conveniently. ',
  cata_basic_intro_title5: 'Task mark completed',
  basic_intro_title5: 'Task mark completed',
  basic_intro_subtitle5: 'One click to complete each task, allowing you to complete each task with a greater sense of accomplishment. ',
  basic_intro_text5: 'Click the edit first button and mark it as complete. ',
  cata_basic_intro_title6: 'Search',
  basic_intro_title6: 'Search',
  basic_intro_subtitle6: 'You can use the search function to search the history. ',
  basic_intro_text6: 'Click the menu bar button on the upper right side of the calendar and select Search. <p class="p" />Enter the keywords you want to find in the search bar, and the system will filter out the schedules that meet the conditions and display them below the search bar. <p class="p" />Double-click any schedule in the search results to enter the editing page and modify the schedule. ',
  cata_basic_intro_title7: 'Repeat tasks',
  basic_intro_title7: 'Repeat tasks',
  basic_intro_subtitle7: 'If you have a frequently recurring schedule, you can easily set up recurring tasks. ',
  basic_intro_text7: 'In the edit box, click the Repeat Task button. Choose the appropriate repeat time and repeat type based on your needs. ',
  cata_basic_intro_title8: 'Teaching Week',
  basic_intro_title8: 'Teaching Week',
  basic_intro_subtitle8: 'For students and teachers, we provide the function of displaying the teaching week. ',
  basic_intro_text8: 'Click the menu button in the upper right corner of the calendar and then click Settings, then select Advanced in the settings dialog box, and finally set the week number of the current semester to "First Week", so that the week number on the left side of the calendar will be displayed as Teaching week. ',
  cata_basic_intro_title9: 'Calendar text size adjustment',
  basic_intro_title9: 'Calendar text size adjustment',
  basic_intro_subtitle9: 'You can set the calendar interface font, text size and text color. ',
  basic_intro_text9: 'Click the menu button in the upper right corner of the calendar and then click Settings, then select the calendar in the settings dialog box, and finally configure the calendar font, size and color. ',
  cata_basic_intro_title10: 'Record content text size adjustment',
  basic_intro_title10: 'Record content text size adjustment',
  basic_intro_subtitle10: 'The text in the cell can be adjusted in size, font and color. ',
  basic_intro_text10: 'Click the menu button in the upper right corner of the calendar and then click Settings, then select the day cell in the settings dialog box, and finally configure the calendar font, size and color. ',
  cata_basic_intro_title7_1: 'Wallpaper Skin',
  basic_intro_title7_1: 'Wallpaper Skin',
  basic_intro_subtitle7_1: 'Give your desktop a new look and express your personality. ',
  basic_intro_text7_1: 'Click the menu button in the upper right corner of the calendar and then click Wallpaper Skin. <p class="p" />If there is no wallpaper skin option in your menu, please <a href="/"> click here </a> to download the latest version. ',

  //便签
  cata_basic_intro_title11: "Note",
  basic_intro_title11: "Note",
  basic_intro_subtitle11: "Equipped with a simple and easy to use note feature.",
  basic_intro_text11: "Click the plugin button in the upper right corner of the calendar to access note-related functions. You can create a new note or configure existing notes.",

  //课程表
  cata_basic_intro_title12: 'Class Schedule',
  basic_intro_title12: 'Class Schedule',
  basic_intro_subtitle12: 'Comes with fully-functional scheduling feature.',
  basic_intro_text12: 'Click the plugin button on the top-right corner of the calendar to access the schedule feature, where you can create new schedules or configure existing ones.',

  // 2024-09-26 新增独家介绍
  exclusive_title: 'Exclusive',
  cata_basic_intro_new_title0: "Zero Ads",
  basic_intro_new_subtitle0: "We firmly believe that no ads mean true efficiency",
  basic_intro_new_text0: "Whether you're a valued paid user or a free user, no matter which platform you're on, CalendarTask is free from any ads, providing a pure and undisturbed experience.",

  cata_basic_intro_new_title1: "Seamlessly Overlay on Desktop ",
  basic_intro_new_subtitle1: "Effortlessly blends with your desktop and wallpaper, allowing for unhindered desktop operations",
  basic_intro_new_text1: "While using the calendar, your mouse's interaction with desktop files and icons remains unaffected.",

  cata_basic_intro_new_title2: "Floating months",
  basic_intro_new_subtitle2: "Displays calendar across months, allowing you to see schedules from the previous or next week(s) regardless of the current month's start or end",
  basic_intro_new_text2: "Click the small arrow menu in the top-right corner of the calendar, enter settings, and toggle between cross-month display and full-month display under Calendar - Display.",

  cata_basic_intro_new_title3: "Hide Rest Days",
  basic_intro_new_subtitle3: "Hide rest days to focus solely on workdays",
  basic_intro_new_text3: "Click the small arrow menu in the top-right corner of the calendar, enter settings, and customize rest days and their visibility under Advanced - Weekly Rest Days.",

  cata_basic_intro_new_title4: "Customizable Rows and Cols",
  basic_intro_new_subtitle4: "Create your personalized calendar view by customizing the number of rows and columns",
  basic_intro_new_text4: "Click the small arrow menu in the top-right corner of the calendar, enter settings, and under Calendar - Display, customize the number of rows and columns to display, allowing you to show only specific weeks or days of the week.",

  cata_basic_intro_new_title5: "All System Support",
  basic_intro_new_subtitle5: "Supported on Windows/Android/iOS/Mac/Linux",
  basic_intro_new_text5: 'Android/iOS/Mac users can search for CalendarTask in their respective app stores for installation. Windows/Linux users can download from our <a href="/">official website homepage</a>.',

  group_intro_title1: 'Share your schedule easily',
  group_intro_subtitle1: 'If you are a small team and want to share and manage schedules with your team members, you can try the team function of CalendarTask.',
  group_intro_text1: 'Click the personal button in the upper right corner of the calendar, then select "Account Settings", then select "Shared Team", and finally add your members in the upper right corner of the page. <p class="p" />To facilitate your management, team members can only be added via email. ',
  group_intro_title2: 'Member schedules are not shared',
  group_intro_subtitle2: 'Only team members can see and edit their own tasks and schedules, and team members will not affect each other. ',
  group_intro_text2: 'Click "Subaccount" in "Account Settings" and then add a subaccount. <p class="p" />Then click "Shared Team" in "Account Settings" and select the corresponding sub-account for the team member in the sub-account display control bar. ',
  group_intro_title3: 'Team members cannot be edited',
  group_intro_subtitle3: 'When you only want to share your schedule and don\'t want team members to edit it, you can set it as read-only for team members. ',
  group_intro_text3: 'Click "Shared Team" in "Account Settings", find the corresponding member and check read-only, and finally save. ',
  group_intro_title4: 'Conveniently view the schedules of all members',
  group_intro_subtitle4: 'You can view all members\' schedules at a glance. ',
  group_intro_text4: 'Select "Main account (display all member content)" in the sub-account menu<p class="p" />If the member\'s displayed content is too much, you can move the mouse to the date, and a completion prompt will be displayed . ',

  pay_new_upgrade_txt1: 'Simply log in with the same account on other devices, and the data will be displayed immediately and synchronized without any other operation.',
  pay_new_upgrade_txt2: 'Not only that, in order to ensure the security of your historical data, the server will also back up your historical data at the same time. <p class="p" />Open the edit box, click the last button in the edit box, and you can view all the history and corresponding functions.',
  pay_new_upgrade_txt3: 'To click on the personal button located in the top right corner of the calendar, then select "Account Settings", and finally "Sub-accounts".',
  pay_new_upgrade_txt4: 'The automatic extension function automatically acquires unfinished tasks from the previous three days and extends them to the next day. When the task is continuously extended to the seventh day, this function will automatically stop and no longer continue to extend the task. <p class="p" />After checking, the task will no longer be automatically extended.',
  pay_new_upgrade_txt5: '',
  pay_new_upgrade_txt6: 'Go to "Account Settings" and then click on "Online Devices".',
  pay_new_upgrade_txt7: 'Free users will be limited to 2 login clients.',
  pay_new_upgrade_txt8: 'The free user cloud only stores data from the last 6 months.',
  pay_new_upgrade_txt9: '',

  cata_pay_new_upgrade_title: 'VIP function',
  cata_pay_new_upgrade_title1: 'Real-time data sync (auto)',
  cata_pay_new_upgrade_title2: 'Auto backup of records',
  cata_pay_new_upgrade_title3: 'Sub-account function',
  cata_pay_new_upgrade_title4: 'Automatically deferred',
  cata_pay_new_upgrade_title5: 'Log in from anywhere',
  cata_pay_new_upgrade_title6: 'Online device viewing',
  cata_pay_new_upgrade_title7: 'Unlimited login clients',
  cata_pay_new_upgrade_title8: 'Cloud persistent storage',
  cata_pay_new_upgrade_title9: 'VIP Exclusive Customer Service',
  pay_new_upgrade_title1: 'Real-time synchronization',
  pay_new_upgrade_title2: 'History function',
  pay_new_upgrade_title3: 'Sub-account function',
  pay_new_upgrade_title4: 'Automatically deferred',
  pay_new_upgrade_title5: 'Log in from anywhere',
  pay_new_upgrade_title6: 'Online device viewing',
  pay_new_upgrade_title7: 'Unlimited login clients',
  pay_new_upgrade_title8: 'Cloud permanent storage of data',
  pay_new_upgrade_title9: 'VIP Exclusive Customer Service',
  pay_new_upgrade_subtitle1: 'You can instantly sync data between multiple devices, such as phones, computers, and ipads.',
  pay_new_upgrade_subtitle2: 'The history is automatically backed up, viewed, and deleted.',
  pay_new_upgrade_subtitle3: 'When you record too many tasks in a day, you can separate them by work, life, and so on.',
  pay_new_upgrade_subtitle4: 'If you record too many tasks in one day and do not complete them, the system will automatically postpone these tasks to the next day.',
  pay_new_upgrade_subtitle5: 'Data can be synchronized instantly between multiple computers at home, work, school, anywhere.',
  pay_new_upgrade_subtitle6: 'Online device management allows you to view online client devices and log out of the displayed device.',
  pay_new_upgrade_subtitle7: 'With the same account, there is no limit on the number of client devices to log in, and you can log in at home, at work, or anywhere.',
  pay_new_upgrade_subtitle8: 'Member user data will be permanently stored in the cloud, and there is no worry about changing devices. Simply log in to your account to access all data.',
  pay_new_upgrade_subtitle9: 'If there are any issues during member usage, our dedicated customer service will prioritize resolving them for you when contacting customer service.',

  pay_payment_method: 'Pay Mode',
  pay_payment_wechat: 'Wechat',
  pay_payment_paypal: 'PayPal',
  pay_upgrade_button: 'Upgrade',
  pay_upgrade_renew_button: 'Renew',
  pay_forpay_left: 'Pay for ',
  pay_forpay_right: '',
  pay_payment_unit: 'USD',
  pay_three_month: '3 months',
  pay_one_year: '1 year',
  pay_three_year: '3 years',
  pay_original_price_threemonth: '4 USD',
  pay_original_price_oneyear: '16 USD',
  pay_original_price_threeyear: '48 USD',
  pay_application: 'CalendarTask',

  cata_team_intro_title1: 'Easily share your schedule',
  cata_team_intro_title2: 'View team members\' records',
  cata_team_intro_title3: 'Read only permission',

  cata_user: 'Free user',
  cata_vip: 'VIP user ',
  cata_vip_team: 'VIP sharing team',

  group_upgrade_button: 'Upgrade team VIP',
  group_title: 'CalendarTask - Shared Team',

  about_us: '',
  copy_right: 'Copyright © 2018 - Now',

  wapper_title: "Free Wallpaper Skin",
  wapper_desc_html: "<p>You are using the installation program downloaded from Windows Store. Due to permission issues, the wallpaper skin function is not available. </p><p class='red'>If you want to use this function, please log in and synchronize the backup data in advance, and then uninstall the Windows Store version. Download the latest installation package <a href='/'>here</a> and install it.</p>",

  v2_slogan_text: "Your Personal Time Management Expert",
  v2_feature_title: "Transparent Display<span class=\"gap\">|</span>Multi-device Data Sync<span class=\"gap\">|</span>Notes<span class=\"gap\">|</span>Countdown Anniversary<span class=\"gap\">|</span>Schedule Reminder",
  v2_feature_title_baseintro: "Transparent Display<span class=\"gap\"></span>Multi-device Data Sync<span class=\"gap\"></span>Notes<span class=\"gap\"></span>Countdown Anniversary<span class=\"gap\"></span>Schedule Reminder",
  v2_content_title_note: "Notes",
  v2_content_title_noad: "No Ads",
  v2_content_text_note: "Stay organized, choose your colors",
  v2_content_text_noad: "Ad-free experience across all channels",

  v2_content_title_reminder: "Notification Reminder",
  v2_content_text_reminder: "Customizable for repetitive, complex tasks and reminders.",

  v2_content_title_countdown: "Countdown Anniversary Card",
  v2_content_text_countdown: "Display elegant cards directly on the desktop to never forget every important day.",

  v2_scan: "Scan",
  v2_down_phone: "Free App Download",

  v2_update_time: "Update Time",
  v2_update_ver: "Latest Version",
  v2_feature_other: "Other Features",
  v2_feature_other_1_title: "Customization",
  v2_feature_other_1_html: "<li>Show lunar calendar, solar terms, holidays</li><li>Set background color for any date</li><li>Custom recurring tasks (daily, weekly, monthly, yearly)</li>",
  v2_feature_other_2_title: "Smart Features",
  v2_feature_other_2_html: "<li>Add tasks with just one click</li><li>Floating calendar for quick task view</li><li>Completed tasks move to the end</li><li>Cloud backup for easy history access</li><li>Unfinished tasks auto-move to the next day</li>",
  v2_feature_other_3_title: "Special Features",
  v2_feature_other_3_html: "<li>Export to Excel (PC version)</li><li>Search to find important tasks</li><li>School week settings (for teachers & students)</li><li>Sub-accounts for work and study separation</li><li>Online device management</li><li>Team version for shared calendars</li>",

  v2_about_us: "About Us",

  v2_feature_exclusive_text: "Exclusive feature",
  v2_feature_vip_text: "VIP feature",
  v2_feature_normal_text: "Basic feature",
  v2_feature_team_text: "Team feature",

  v2_ver_free_title: "Free Version",
  v2_ver_free_desc: "Suitable for personal local use",
  v2_ver_vip_title: "VIP Version",
  v2_ver_vip_desc: "Ideal for individual use, supports multi-device sync",
  v2_ver_team_title: "Team Version",
  v2_ver_team_desc: "Designed for small to medium team collaboration",

  v2_ver_free_equity: "Basic Features",
  v2_ver_vip_equity: "Premium Features",
  v2_ver_team_equity: "Team Features",
  v2_ver_equity_support: "Supported",

  v2_ver_include_base: "Includes basic features",
  v2_ver_include_vip: "Includes premium features",

  v2_down_btn_text: "Free Download",

  v2_sub_title: "No Procrastination, Efficient Life",
  v2_www_link: "Official Homepage",
  v2_pay_btn_text: "Upgrade Now",
  v2_team_days_desc: "10 users per year",
  v2_team_btn: "View Team Version"

};
exports["default"] = en_US;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./lang/en_US.js
// module id = 301
// module chunks = 0